import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Throwing } from '../models/common';
import { webApiGet, webApiPost } from '../api/client';
import { AppThunk } from '../store/store';


export interface SupplierPaymentState extends Throwing {
  getStripeRegisterLinkBusy: boolean,
  stripeRegisterLink: string | null,

  registerStripeUserBusy: boolean,
  registerStripeUserSuccess: boolean | null,

  getStripeDashboardLinkBusy: boolean,
  stripeDashboardLink: string | null,
}
const initialState: SupplierPaymentState = {
  getStripeRegisterLinkBusy: false,
  stripeRegisterLink: null,
  
  registerStripeUserBusy: false,
  registerStripeUserSuccess: null,

  getStripeDashboardLinkBusy: false,
  stripeDashboardLink: null,
};

export const supplierPaymentSlice = createSlice({
  name: 'supplierPayment',
  initialState,
  reducers: {
    getStripeRefLink_REQUEST: (state) => {
      state.getStripeRegisterLinkBusy = true
      state.error = undefined
    },
    getStripeRefLink_RESPONSE: (state, action: PayloadAction<{ link: string }>) => {
      state.getStripeRegisterLinkBusy = false
      state.stripeRegisterLink = action.payload.link
    },
    getStripeRefLink_ERROR: (state, action: PayloadAction<Error>) => {
      state.getStripeRegisterLinkBusy = false
      state.error = action.payload
    },


    registerStripeUser_REQUEST: (state) => {
      state.registerStripeUserBusy = true
      state.registerStripeUserSuccess = null
      state.error = undefined
    },
    registerStripeUser_RESPONSE: (state, action: PayloadAction<boolean>) => {
      state.registerStripeUserBusy = false
      state.registerStripeUserSuccess = action.payload
    },
    registerStripeUser_ERROR: (state, action: PayloadAction<Error>) => {
      state.registerStripeUserBusy = false
      state.registerStripeUserSuccess = false
      state.error = action.payload
    },


    getStripeDashboardLink_REQUEST: (state) => {
      state.getStripeDashboardLinkBusy = true
      state.error = undefined
    },
    getStripeDashboardLink_RESPONSE: (state, action: PayloadAction<{ link: string }>) => {
      state.getStripeDashboardLinkBusy = false
      state.stripeDashboardLink = action.payload.link
    },
    getStripeDashboardLink_ERROR: (state, action: PayloadAction<Error>) => {
      state.getStripeDashboardLinkBusy = false
      state.error = action.payload
    },
  }
});

export const getStripeRefLinkAsync = (): AppThunk => dispatch => {
  dispatch(supplierPaymentSlice.actions.getStripeRefLink_REQUEST())

  webApiGet(
    "/supplierpayment/register/link",
    (data: any) => {
      dispatch(supplierPaymentSlice.actions.getStripeRefLink_RESPONSE(data));
    },
    (error: Error) => {
      dispatch(supplierPaymentSlice.actions.getStripeRefLink_ERROR(error));
    }, null, 3
  )
};

export const registerSupplierStripeUserAsync = (stateSecurityCode: string, accessToken: string): AppThunk => dispatch => {
  dispatch(supplierPaymentSlice.actions.registerStripeUser_REQUEST())

  webApiPost(
    "/supplierpayment/register",
    { stateSecurityCode, accessToken },
    (data: any) => {
      dispatch(supplierPaymentSlice.actions.registerStripeUser_RESPONSE(data));
    },
    (error: Error) => {
      dispatch(supplierPaymentSlice.actions.registerStripeUser_ERROR(error));
    }
  )
};

export const getStripeDashboardLinkAsync = (): AppThunk => dispatch => {
  dispatch(supplierPaymentSlice.actions.getStripeDashboardLink_REQUEST())

  webApiGet(
    "/supplierpayment/dashboard",
    (data: any) => {
      dispatch(supplierPaymentSlice.actions.getStripeDashboardLink_RESPONSE(data));
    },
    (error: Error) => {
      dispatch(supplierPaymentSlice.actions.getStripeDashboardLink_ERROR(error));
    }, null, 3
  )
};

export default supplierPaymentSlice.reducer;